import { LitElement, TemplateResult, css, html } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import { resolveRouterPath, router } from '../../src/router/router';

import '@shoelace-style/shoelace/dist/components/button/button.js';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { collection, doc, getDoc, getDocs, getFirestore, query, where } from 'firebase/firestore';

@customElement('app-header')
export class AppHeader extends LitElement {
  @property({ type: Boolean }) enableBack: boolean = false;
  @property({ type: String }) profilePicUrl: string = '';
  @property({ type: String }) pageTitle: string = ''; // New property for page title
  @state() isSidebarOpen = false; // Sidebar state for toggle
  @state() isLoggedIn = false; // New state for logged-in status
  @state() user: any = null;
  @state() isAdmin: boolean = false;
@state() isCaptain: boolean = false;
@state() isPlayer: boolean = false;
@state() isFinance: boolean = false;
@state() private currentSeason = '';
@state() private membershipPaid = false;
@state() private membershipChecked = false;


connectedCallback() {
  super.connectedCallback();
  this.profilePicUrl = localStorage.getItem('profilePicUrl') || '';
  this.fetchCurrentSeason().then(() => {
    // …then wire up auth (so fetchMembershipFlag will see currentSeason!)
    this.initAuth();
  });
}

  private initAuth() {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        this.user = user;
        this.isLoggedIn = true;
        if (!this.currentSeason) {
          await this.fetchCurrentSeason();
        }
        await this.fetchUserRole(user.uid);
        await this.fetchMembershipFlag(user.uid);
      } else {
        this.user = null;
        this.isLoggedIn = false;
        router.navigate(resolveRouterPath('login'));
      }
    });
  }
/** Get the single active season ID from Firestore */
private async fetchCurrentSeason() {
  const db = getFirestore();
  const seasonsRef = collection(db, 'Seasons');
  const q = query(seasonsRef, where('endseason', '==', false));
  const snap = await getDocs(q);
  if (!snap.empty) {
    this.currentSeason = snap.docs[0].id;
  } else {
    console.warn('No active season found');
  }
}

/** After we know the season and the user, load their paid‐status flag */
private async fetchMembershipFlag(uid: string) {
  if (!this.currentSeason) return;
  const db   = getFirestore();
  const path = `Seasons/${this.currentSeason}/Players/${uid}`;
  const snap = await getDoc(doc(db, path));
  const data = snap.data() || {};

  // look for either field name (with or without trailing space)
  const paid1 = data.membershipPaid;
  const paid2 = (data as any)['membershipPaid '];  // note the space

  this.membershipPaid    = paid1 === true || paid2 === true;
  this.membershipChecked = true;
}



  async fetchUserRole(userId: string) {
    const db = getFirestore(); // Assume Firestore is used
    const userRef = doc(db, `Player/${userId}`); // Adjust to your user collection path
    const userDoc = await getDoc(userRef);

    if (userDoc.exists()) {
      const userData = userDoc.data();
      const userType = userData.type;

      // Set the permissions based on the user type
      this.isAdmin = userType === 'Admin';
      this.isCaptain = userType === 'Captain';
      this.isPlayer = userType === 'Player';
      this.isFinance = userType === 'Finance';
    } else {
      console.error('User document not found');
    }
  }



  async fetchUserName(userId: string) {
    // Fetch user name logic here (if necessary)
    console.log(`Fetch user details for userId: ${userId}`);
  }

  static styles = css`
    header {
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--app-color-primary);
      color: white;
      font-weight: bold;
      font-size: 24px;
      padding: 0 16px;
      position: fixed;
      left: 0;
      top: 0;
      height: 4em;
      width: 100%;
      background-image: url('/assets/images/mainbackground.jpeg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 1000;
    }

    .hamburger {
      position: fixed;
      top: 20px;
      left: 20px;
      z-index: 2000;
      cursor: pointer;
      background-color: transparent;
      border: none;
      font-size: 24px;
      color: white;
      pointer-events: auto;
    }

    #sidebar {
      background-color: white;
      position: fixed;
      top: 0;
      left: 0;
      transform: translateX(-100%);
      width: 250px;
      transition: transform 0.3s ease-in-out;
      z-index: 3000;
      box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
      overflow-y: auto;
       height: 100vh;
       color: black;
    }

    #sidebar.open {
      transform: translateX(0%);
    }

    .exit-sidebar {
      background: none;
      border: none;
      font-size: 24px;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 3100;
    }

    .menu-section {
      padding: 10px;
      font-size: 16px;
    }

    .menu-section a {
      display: block;
      padding: 10px;
      text-decoration: none;
      color: black;
    }

    .menu-section a:hover {
      background-color: #f1f1f1;
    }

    .logout-button {
      display: block;
      width: 100%;
      padding: 10px;
      background-color: #e74c3c;
      color: white;
      border: none;
      cursor: pointer;
    }

    .logout-button:hover {
      background-color: #c0392b;
    }

    @media (prefers-color-scheme: light) {
      header {
        color: white

      }
      nav a {
        color: initial;
      }
    }
  `;

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  private renderSidebarLinks(): TemplateResult {
    return html`
      <div class="welcome-message">Appleton CC</div>

      <!-- Always-visible links -->
      <div class="menu-section">
        <a href="${resolveRouterPath('home')}"><span>🏠</span> Home</a>
        <a href="${resolveRouterPath('availability')}"><span>✅</span> Availability</a>
<a href="${resolveRouterPath('fixtures')}"><span>📅</span> Fixtures</a>
        <a href="${resolveRouterPath('events')}"><span>📅</span> Events</a>
        <a href="${resolveRouterPath('results')}"><span>🏅</span> Results</a>
        <a href="${resolveRouterPath('leaderboard')}"><span>📈</span> Leaderboard</a>
        <a href="${resolveRouterPath('honours-board')}"><span>🏏</span> Honours Board</a>

                        ${this.isAdmin
                ? html`<a href="${resolveRouterPath('admin')}"><span>🗝️</span> Admin Hub</a>`
                : ''}
      </div>

      <!-- if we haven't loaded membership yet, show nothing further -->
      ${!this.membershipChecked
        ? html`<div class="menu-section">Loading…</div>`
        : !this.membershipPaid
          ? html`
            <div class="menu-section">
              <p>The rest of the features will be unlocked soon.</p>
            </div>
          `
          : html`
            <!-- Paid users get the full menu -->
            <div class="menu-section">


            </div>

            <div class="menu-section">
              <h2>My Performance</h2>
              <a href="${resolveRouterPath('stats')}"><span>🏏</span>My Stats</a>
              <a href="${resolveRouterPath('finance-player')}"><span>💼</span>My Finance</a>
            </div>





            ${this.isAdmin || this.isFinance
              ? html`
                <div class="menu-section">

                    <a href="${resolveRouterPath('finance-admin')}"><span>💼</span> Finance Admin</a>
                </div>
              `
              : ''
            }
          `
      }

      <!-- Always-visible logout -->
      ${this.isLoggedIn
        ? html`
          <div class="menu-section">
            <a href="${resolveRouterPath('settings')}"><span>⚙️</span> Settings</a>
            <button class="logout-button" @click=${this.handleLogout}>
              🚪 Logout
            </button>
          </div>
        `
        : ''
      }
    `;
  }
  handleLogout() {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        console.log('Logged out');
        this.isLoggedIn = false;
        router.navigate(resolveRouterPath('login'));
      })
      .catch((error) => {
        console.error('Error logging out:', error);
      });
  }

  render() {
    return html`
      <header>
        <!-- Page Title in the Center -->
        <div id="title">${this.pageTitle}</div>

        <!-- Sidebar -->
        <button @click="${this.toggleSidebar}" class="hamburger">☰</button>
        <div id="sidebar" class="${this.isSidebarOpen ? 'open' : ''}">
          <button @click="${this.toggleSidebar}" class="exit-sidebar">✖️</button>
          ${this.renderSidebarLinks()}
        </div>
      </header>
    `;
  }
}
